import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// CUSTOMER APIS
// ================================

// 🔹 GET CUSTOMER LIST
export async function getCustomerList(
  user_tags = "Review",
  user_activity = "none",
  filters = "",
  search_key = "",
  page = "0",
  user_id="",
  activeStarFilters = []
) {
  try {
    const fd = new FormData();
    fd.append("filters", filters);
    fd.append("search_key", search_key);
    fd.append("user_activity", user_activity);
    fd.append("user_tags", user_tags);
    fd.append("page", page);
    fd.append("user_id", user_id);
    fd.append("activeStarFilters", JSON.stringify(activeStarFilters));
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);


    const response = await axios.post(`${apiBaseUrl}customerapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCustomerList error:", error);
    return { status: false, type: "danger", success: "Failed to fetch customers" };
  }
}

// 🔹 UPDATE CUSTOMER STATUS
export async function updateCustomerStatus(user_id, user_status) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("user_status", user_status);

    const response = await axios.post(`${apiBaseUrl}customerapis/update_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateCustomerStatus error:", error);
    return { status: false, type: "danger", success: "Status update failed" };
  }
}

// 🔹 KPI STATS
export async function getCustomerKpiStats(user_id) {
  try {
    const fd = new FormData();
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);
    fd.append("user_id", user_id);


    const response = await axios.post(`${apiBaseUrl}customerapis/kpi_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCustomerKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load KPI stats" };
  }
}

// 🔹 CREATE CUSTOMER
export async function createCustomer(
  user_id,
  user_name,
  user_email,
  user_mobile,
  location,
  tag,
  cre_by
) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("user_name", user_name);
    fd.append("user_email", user_email);
    fd.append("user_mobile", user_mobile);
    fd.append("location", location);
    fd.append("tag", tag);
    fd.append("cre_by", cre_by);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}customerapis/create_customer`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createCustomer error:", error);
    return { status: false, type: "danger", success: "Customer creation failed" };
  }
}

// 🔹 GET CUSTOMER DETAILS
export async function getCustomerDetails(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}customerapis/get_details`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCustomerDetails error:", error);
    return { status: false, type: "danger", success: "Failed to load customer details" };
  }
}

export async function deleteCusNow(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}customerapis/del_customer`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCustomerDetails error:", error);
    return { status: false, type: "danger", success: "Failed to load customer details" };
  }
}